import { TwilioVerificationChannelEnum, useTwilioSendCodeMutation } from '@alluradirect/react';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';
import { useFormikContext } from 'formik';
import { useListModalContext } from '../listModalContext';

export const listSendTwilioVerificationMutationKey = 'sendTwilioVerification';

export const ListPageSendVerificationButton = ({
  text,
  onClick = () => null,
}: {
  text: string;
  onClick?: () => void;
}) => {
  const {
    listFormValues: { email },
  } = useListModalContext();

  const { resetForm } = useFormikContext<{ code: string }>();

  const sendTwilioVerification = useTwilioSendCodeMutation({
    mutationKey: listSendTwilioVerificationMutationKey,
  });

  const handleResendVerification = () => {
    resetForm();
    onClick();
    sendTwilioVerification.mutate({
      value: email,
      channel: TwilioVerificationChannelEnum.email,
    });
  };

  return (
    <LoadingButton
      onClick={handleResendVerification}
      variant="text"
      buttonColor="secondary"
      isFullWidth
      size="large"
      isLoading={sendTwilioVerification.isLoading}
    >
      {text}
    </LoadingButton>
  );
};
